import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ShopifyPruchase } from 'src/app/services/jsonrpc/shopify-server.service';

@Component({
  selector: 'app-shopify-purchase-modal',
  templateUrl: './shopify-purchase-modal.component.html',
  styleUrls: ['./shopify-purchase-modal.component.scss']
})
export class ShopifyPurchaseModalComponent {
  @Input() public purchase: ShopifyPruchase;
  @Output() onSubmit = new EventEmitter<ShopifyPruchase>();

  constructor(public modal: NgbActiveModal) {}

  public get isValidMail(): boolean {
    return this.purchase.recipient.match(/^.+@.+\..+$/) != null;
  }

  public get isValid(): boolean {
    return this.isValidMail && this.purchase.firstName !== '' && this.purchase.lastName !== '';
  }

  public submit() {
    this.onSubmit.emit(this.purchase);
    this.modal.close();
  }
}
